import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import { CargueV, CargueService } from '../services/cargue_archivo.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-cargue-archivos',
  templateUrl: './cargue-archivo.component.html',
  styleUrls: ['./cargue-archivo.component.scss'],
  styles: [
    `
    @media only screen and (max-width: 500px) {
      .card-body {
          flex-wrap: wrap
        }
      }
      `
  ]
})
export class CargueArchivosComponent implements OnInit {

  file: File;
  recordsToSend: number = 1000; //--> No de registros que se enviarán en cada request
  reader = new FileReader();
  isFileLoaded: boolean = false
  isFileProce: boolean = false
  textFileLoaded: String
  lastTextFileLoaded: String
  csvMatriz: string[] = [];
  csvHeader: string[] = [];
  parsedInfo: any[] = []
  incorrectInfo: any[] = []
  inputFile: HTMLInputElement

  cargueForm: FormGroup = new FormGroup({
    periodo: new FormControl('', [Validators.required, Validators.pattern(/^.{4,6}$/)]
    ),
  })

  constructor(private notificationService: NotificationHelper,
    private cargueService: CargueService,
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
  ) {
    this.reader.addEventListener('load', (event) => {
      showSpinner()
      this.textFileLoaded = this.reader.result ? this.reader.result as string : "";
      this.csvMatriz = this.textFileLoaded.split(/\r\n|\n/)
      try {
        this.onLoadFile()
      } catch (error: any) {
        this.notificationService.errorMessage(error.message)
      }
      hideSpinner()
    });
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
  }

  // Funciones utilitarias
  validarCamposNumericos(valor) {
    const patron = /^[0-9]+$/;
    return patron.test(valor);
  }

validarFecha(fecha) {
  var regexFecha = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  return regexFecha.test(fecha);
}
  onSelectFile(e: HTMLInputElement) {
      
    this.parsedInfo = []
    this.incorrectInfo = []

    showSpinner()
    console.log('onSelectFile')
    this.inputFile = e
    const files = this.inputFile.files;
    if (files && files.length) {
      this.reader.readAsText(files[0]);
    } else {
      this.notificationService.errorMessage("No se seleccionó ningún archivo.");
    }
    hideSpinner();
  }
	onLoadFile() {
    console.log('onLoadFile')
    showSpinner();
    if (this.csvMatriz == undefined || this.csvMatriz.length <= 0) {
      throw new Error("Este archivo no contiene datos.");
    }
    //Sacar el primer registro (debe contener los encabezados)
    const shift = this.csvMatriz.shift();
    if (!shift) {
      throw new Error("Error eliminando encabezados")
    }
    //Obtenemos el header
    this.csvHeader = shift.replace(/"/g, '').toUpperCase().split(",");
    console.log(this.csvHeader)
    if (!(this.csvHeader[0].toUpperCase() == "AGENCIA" &&
      this.csvHeader[1].toUpperCase() == "TIPO CREDITO" &&
      this.csvHeader[2].toUpperCase() == "NUMERO DE CUENTA" &&
      this.csvHeader[3].toUpperCase() == "CODIGO" 
    )
    ) {
      throw new Error("Este archivo no tiene el formato requerido.")
    }
    if (this.csvMatriz.length <= 0) {
      throw new Error("El archivo tiene el formato, pero no tiene registros.");
    }

    this.csvMatriz.forEach((value, index) => {
      const split = value.replace(/"/g, '').toUpperCase().split(",");
      if (split.length == 4) {
        const item: CargueV = {
          agencia: split[0] ? split[0] : "",
          tipo_credito: split[1] ? split[1] : "",
          num_cuenta: split[2] ? split[2] : "",
          codigo: split[3] ? split[3] : "",
        }
        if (item.num_cuenta && 
          this.validarCamposNumericos(item.codigo) 
        ) {
          this.parsedInfo.push(item);
        } else {
          this.incorrectInfo.push(item)
        }
      }

    }
    );

    if (this.incorrectInfo.length > 0) {
      this.notificationService.warningMessage(`Se encontraron ${this.incorrectInfo.length} registros no válidos.`)
    } else if(this.parsedInfo.length > 0) {
      this.notificationService.infoMessage(`Se encontraron ${this.parsedInfo.length} registros válidos.`)
      this.enableSendButton()
    }
    hideSpinner()
  }

	disableButtonAndDeleteLoadedInfo() {
    this.parsedInfo = [];
    this.csvMatriz = [];
    this.csvHeader = [];
    this.isFileLoaded = false;
    this.incorrectInfo = []
  }

  enableSendButton() {
    this.isFileLoaded = true;
  }
  enableProcButton() {
    this.isFileProce = true;
  }

  ngOnInit(): void {

  }
  onResetForm() {
    this.cargueForm.reset();
  }

	ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    for (let index in headerList) {
    row += headerList[index] + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';

    for (let index in headerList) {
      let head = headerList[index];
      line +=  array[i][head]+';';
    }

    str += line + '\r\n';
    }
    return str;
  }

  doFile(data, filename='data') {
    let csvData = this.ConvertToCSV(data, Object.keys(data[0]));
    let dataFile = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    return dataFile

  }

	async onSumbit(): Promise<void> {
    if (this.parsedInfo.length > 0) {
      const divisor = this.parsedInfo.length / this.recordsToSend;
      let dividedData: any[] = [];

      for (let i = 0; i < divisor; i++) {
        const element = this.parsedInfo.slice(i * this.recordsToSend, (i + 1) * this.recordsToSend);
        dividedData.push(element)
      }
      let contador= 1;
      for(let element of   dividedData){
        let porcentaje = Math.round((contador / dividedData.length) * 100);
        showSpinner(`Cargando Registros  ${porcentaje} %...`);
        try {
        
          const res = await this.cargueService.cargue('JA', element);
          
          if(!res.success) {
            this.notificationService.errorMessage(res.message);
            hideSpinner();
            return;
          }
        } catch (error) {
          console.error(error);
          this.notificationService.errorMessage("Ocurrio un error desconocido.")
          hideSpinner();
          return;
        }
        contador++;
      }
      hideSpinner()
      this.notificationService.successMessage("Cargo correctamente")
      this.isFileLoaded = false;
      this.enableProcButton()
      // location.reload()
    } else {
      this.notificationService.infoMessage("No hay nada que enviar")
    }
    
    this.inputFile.value = ""
  }

  async onProcess(): Promise<void> { 
        showSpinner(`Procesando Registros `);
        try {
            const resp = await this.cargueService.procesador('JA');
            
            if (resp['success']) {
              this.notificationService.successMessage("Procesado correctamente");
              hideSpinner();
              location.reload();
              return;
            }
          }
        catch (error) {
          this.notificationService.errorMessage("Ocurrió un error desconocido.");
          hideSpinner();
          return;
        }
      }
    
}